const COLOR_PALETTE = [
    "rgba(9, 127, 159, 0.6)",      // 1. Tu color azul original
    "rgba(255, 205, 40, 0.6)",     // 2. Tu color amarillo original
    "rgba(255, 99, 132, 0.6)",     // 3. Rosa
    "rgba(54, 162, 235, 0.6)",     // 4. Azul claro
    "rgba(255, 159, 64, 0.6)",     // 5. Naranja
    "rgba(153, 102, 255, 0.6)",    // 6. Púrpura
    "rgba(75, 192, 192, 0.6)",     // 7. Turquesa
    "rgba(255, 99, 71, 0.6)",      // 8. Tomate
    "rgba(106, 90, 205, 0.6)",     // 9. Azul pizarra
    "rgba(34, 193, 195, 0.6)",     // 10. Cian
    "rgba(253, 187, 45, 0.6)",     // 11. Amarillo mostaza
    "rgba(63, 81, 181, 0.6)",      // 12. Índigo
    "rgba(0, 150, 136, 0.6)",      // 13. Verde azulado
    "rgba(233, 30, 99, 0.6)",      // 14. Rosa intenso
    "rgba(121, 85, 72, 0.6)",      // 15. Marrón
    "rgba(255, 152, 0, 0.6)",      // 16. Naranja profundo
    "rgba(103, 58, 183, 0.6)",     // 17. Púrpura profundo
    "rgba(0, 188, 212, 0.6)",      // 18. Cian claro
    "rgba(139, 195, 74, 0.6)",     // 19. Verde lima
    "rgba(255, 87, 34, 0.6)",      // 20. Naranja intenso
    "rgba(96, 125, 139, 0.6)",     // 21. Gris azulado
    "rgba(244, 67, 54, 0.6)",      // 22. Rojo
    "rgba(156, 39, 176, 0.6)",     // 23. Púrpura brillante
    "rgba(33, 150, 243, 0.6)",     // 24. Azul brillante
    "rgba(76, 175, 80, 0.6)",      // 25. Verde
    "rgba(255, 235, 59, 0.6)",     // 26. Amarillo brillante
    "rgba(255, 193, 7, 0.6)",      // 27. Ámbar
    "rgba(205, 220, 57, 0.6)",     // 28. Lima claro
    "rgba(171, 71, 188, 0.6)",     // 29. Púrpura medio
    "rgba(38, 198, 218, 0.6)",     // 30. Cian brillante
    "rgba(102, 187, 106, 0.6)",    // 31. Verde claro
    "rgba(255, 138, 101, 0.6)",    // 32. Coral
    "rgba(126, 87, 194, 0.6)",     // 33. Violeta
    "rgba(41, 182, 246, 0.6)",     // 34. Azul cielo
    "rgba(174, 213, 129, 0.6)",    // 35. Verde pálido
    "rgba(255, 112, 67, 0.6)",     // 36. Naranja rojizo
    "rgba(149, 117, 205, 0.6)",    // 37. Lavanda
    "rgba(77, 208, 225, 0.6)",     // 38. Turquesa claro
    "rgba(220, 231, 117, 0.6)",    // 39. Amarillo verdoso
    "rgba(240, 98, 146, 0.6)",     // 40. Rosa medio
    "rgba(128, 203, 196, 0.6)",    // 41. Verde agua
    "rgba(255, 171, 145, 0.6)",    // 42. Melocotón
    "rgba(179, 157, 219, 0.6)",    // 43. Lila
    "rgba(129, 212, 250, 0.6)",    // 44. Azul bebé
    "rgba(197, 225, 165, 0.6)",    // 45. Verde menta
    "rgba(255, 138, 128, 0.6)",    // 46. Salmón
    "rgba(186, 104, 200, 0.6)",    // 47. Orquídea
    "rgba(100, 181, 246, 0.6)",    // 48. Azul acero
    "rgba(174, 234, 0, 0.6)",      // 49. Verde neón
    "rgba(255, 145, 77, 0.6)"      // 50. Naranja suave
];

export default COLOR_PALETTE;